export default {
  "viewMode": "hXeF-",
  "editMode": "lnPv5",
  "container": "WuiJ8",
  "cell": "cHpsF"
};